<!-- @format -->

<template>
	<pc-card
		:id="item.code"
		:class="item.pcProps.showType === '0' ? 'sub-table-widget' : 'sub-table-widget-form'"
		:header="item.pcProps.isHiddenLabel ? '' : item.pcProps.label"
	>
		<template v-if="!item.children.length">
			<el-empty class="not-content" :image-size="50" description="请从左侧拖拽字段" />
		</template>
		<header class="sub-table-widget-header">
			<template v-if="item.pcProps.actionButton.buttons">
				<template v-for="itm in item.pcProps.actionButton.buttons" :key="itm.code">
					<el-button
						:type="itm.style"
						:circle="itm.circle"
						:style="{ height: `${itm.height}`, width: `${itm.width}` }"
						:icon="itm.icon"
					>
						<div v-html="itm.label" />
					</el-button>
				</template>
			</template>
			<template v-else>
				<el-button v-for="itm in item.pcProps.actionButton" :key="itm.code" v-bind="getBtnProps(itm.code)">
					{{ itm.label }}
				</el-button>
			</template>
		</header>
		<slot :prop="prop"></slot>
	</pc-card>
</template>

<script setup lang="ts">
	import type { Container } from '../../../types';
	import { getBtnProps } from '@/utils/btn';
	import { PcCard } from '@/components';

	interface Props {
		item: Container;
	}

	withDefaults(defineProps<Props>(), {});

	const prop = {
		isFieldToContainer: true,
		isContainerToContainer: false,
	};
</script>

<style scoped lang="scss">
	.sub-table-widget-form {
		width: 100%;

		:deep(.el-card__body) {
			padding: 10px;
			display: flex;
			flex-direction: column;
			gap: 10px;
			position: relative;

			.not-content {
				height: 100px;
				width: 100%;
				position: absolute;
				bottom: 10px;
			}

			.widget-form {
				min-height: 100px;
			}
		}
	}

	.sub-table-widget {
		width: 100%;

		:deep(.el-card__body) {
			padding: 10px;
			display: flex;
			flex-direction: column;
			gap: 10px;
			position: relative;

			.not-content {
				height: 100px;
				width: 100%;
				position: absolute;
				bottom: 10px;
			}

			.widget-form {
				min-height: 100px;

				// ****************覆盖widget-form样式****************
				padding: 0;
				border: 1px solid var(--el-border-color-light);
				flex-wrap: nowrap;
				overflow: auto;

				.widget-form-col {
					padding: 0;
					margin: 0;

					.el-form-item {
						margin: 0;
						flex-direction: column;

						.el-form-item__label-wrap {
							background-color: #f6f6f6;
							border-bottom: 1px solid var(--el-border-color-light);
							margin: 0 !important;
							padding: 3px 10px;
						}

						.el-form-item__content {
							padding: 10px;
						}
					}
				}
			}
		}
	}
</style>
